import { MenuScheduleSettingsBuilder, WeeklyHoursOfOperation } from "./menu.schedule.builder";
import { DayOfWeekSchedule } from "../../product/enums";
import { StringTimeframe } from "../../timeframe/string-timeframe.model";

export class MenuScheduleSettings {
  public readonly availability: StringTimeframe;
  public readonly blackout: StringTimeframe[];
  public readonly dow: DayOfWeekSchedule;
  public readonly hours: WeeklyHoursOfOperation;
  constructor(builder: MenuScheduleSettingsBuilder) {
    this.dow = builder.dow;
    this.availability = new StringTimeframe(builder.availability);
    this.blackout = builder.blackout.map(
      builder => new StringTimeframe(builder)
    );
    this.hours = builder.hours;
  }
}
